import {Text} from '@travel-frontend/core';
import {IconChevronBottom, IconChevronTop} from '@travel-frontend/icons';
import {ActionLink, useBooleanToggle} from '@travel-frontend/ui-components';
import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import {Container} from '@/components/ActiveFilters/components/Container';
import {Headline} from '@/components/ActiveFilters/components/Headline';
import {ToggleCollapse} from '@/components/ActiveFilters/components/ToggleCollapse';
import {CollapsibleSimple} from '@/components/CollapsibleSimple';
import {CountBadge} from '@/components/CountBadge';

type Props = React.PropsWithChildren<{
  count: number;
}>;

export const ActiveFilters = ({count, children}: Props) => {
  const {t} = useTranslation('filters');

  const [touched, setTouched] = useBooleanToggle(false);
  const [expanded, setExpanded] = useBooleanToggle(count <= 3);

  useEffect(() => {
    if (!touched) {
      setExpanded(count <= 3);
    }
  }, [count, setExpanded, touched]);

  return (
    <Container>
      <Headline>
        <Text preset="labelLargeBold">
          {t('chips.activeFilters')} <CountBadge count={count} />
        </Text>
        <ToggleCollapse>
          <ActionLink
            size="small"
            onClick={() => {
              setExpanded();
              setTouched(true);
            }}
            data-testid="expand"
            bold
          >
            {expanded ? (
              <>
                Einklappen <IconChevronTop />
              </>
            ) : (
              <>
                Ausklappen <IconChevronBottom />
              </>
            )}
          </ActionLink>
        </ToggleCollapse>
      </Headline>
      <CollapsibleSimple open={expanded}>{children}</CollapsibleSimple>
    </Container>
  );
};
